// extracted by mini-css-extract-plugin
export default {"products":"QB-z","card":"RB-z","oosMessaging":"SB-z"};